// export const main = "http://127.0.0.1:12348";
// export const host_url = "http://127.0.0.1:12348";
// export const uploadUrl = "http://127.0.0.1:22348";
// export const fileUrl = uploadUrl;

export const main = "https://eprpc.wowdb.cc";
export const host_url = "https://eprpc.wowdb.cc";
export const uploadUrl = "https://epfile.wowdb.cc";
export const fileUrl = uploadUrl;